import { Route } from '@angular/router';
import { RoutingID } from '../../../../sb-routing-enum';
import { RepositoriesListComponent } from '../../../../../pages/assets/datasets/repositories-list/repositories-list.component';
import { AssetListComponent } from '../../../../../pages/assets/datasets/asset-list/asset-list.component';
import { AssetCategoryListComponent } from '../../../../../pages/assets/datasets/asset-category-list/asset-category-list.component';
import { SbIcons } from '@ngx-seatback/icons';

export const repositories: Route = {
  path: 'repositories',
  title: 'nav.repositories',
  data: {
    id: RoutingID.repositories,
    breadcrumb: 'nav.repositories',
    icon: SbIcons.folderPhoto,
  },

  children: [
    {
      path: '',
      component: RepositoriesListComponent,
      data: {
        breadcrumb: '',
      },
    },
    {
      path: ':repositoryID/assets',
      title: 'nav.assets',
      data: {
        breadcrumb: 'nav.assets',
        icon: SbIcons.photos,
        id: RoutingID.assets,
      },
      children: [
        {
          path: '',
          component: AssetListComponent,
          data: {
            breadcrumb: '',
          },
        },
      ],
    },
    {
      path: ':repositoryID/assetCategories',
      title: 'nav.assetCategories',
      data: {
        breadcrumb: 'nav.assetCategories',
        icon: SbIcons.category,
        id: RoutingID.assetCategories,
      },
      children: [
        {
          path: '',
          component: AssetCategoryListComponent,
          data: {
            breadcrumb: '',
          },
        },
      ],
    },
  ],
};
